import { render } from "./FormUpload.vue?vue&type=template&id=7cfd81a4&scoped=true"
import script from "./FormUpload.vue?vue&type=script&lang=js"
export * from "./FormUpload.vue?vue&type=script&lang=js"

import "./FormUpload.vue?vue&type=style&index=0&id=7cfd81a4&scoped=true&lang=css"

import exportComponent from "/home/xs551928/niidaphoto.com/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfd81a4"]])

export default __exports__